// Tenant Portal analytics events (v1). Tenant-only, post-sign-in.
// See docs/TENANT_PORTAL_ANALYTICS_EVENTS.md. Fired via useAnalytics().track(EVENTS.X, {props}).
const EVENTS = Object.freeze({
  // --- pre-existing (kept) ---
  RENT_COLLECTED:              'rent_collected',
  MAINTENANCE_REQUEST_CREATED: 'maintenance_request_created',
  LEASE_UPLOADED:              'lease_uploaded',
  REPORT_GENERATED:            'report_generated',
  PAYMENT_SENT:                'payment_sent',
  TASK_FAILED:                 'task_failed',
  AGENT_HANDOFF_TRIGGERED:     'agent_handoff_triggered',
  FEATURE_FIRST_USED:          'feature_first_used',

  // --- Rent Payments ---
  PAYMENT_INITIATED:               'payment_initiated',
  PAYMENT_COMPLETED:               'payment_completed',   // ACH only (client-side)
  PAYMENT_FAILED:                  'payment_failed',      // ACH only (client-side)
  DUPLICATE_PAYMENT_WARNING_SHOWN: 'duplicate_payment_warning_shown',
  DUPLICATE_PAYMENT_CONFIRMED:     'duplicate_payment_confirmed',
  PAYMENT_HISTORY_VIEWED:          'payment_history_viewed',

  // --- Autopay ---
  AUTOPAY_ENABLED:            'autopay_enabled',
  AUTOPAY_UPDATED:            'autopay_updated',
  AUTOPAY_DISABLED:           'autopay_disabled',
  AUTOPAY_MISMATCH_DISMISSED: 'autopay_mismatch_dismissed',

  // --- Bank Accounts (Plaid / Dwolla) ---
  BANK_LINK_STARTED:    'bank_link_started',
  BANK_LINK_EXITED:     'bank_link_exited', // Plaid Link closed without success (cancel or error)
  BANK_ACCOUNT_LINKED:  'bank_account_linked',
  BANK_ACCOUNT_ADDED:   'bank_account_added',
  BANK_ACCOUNT_REMOVED: 'bank_account_removed',
  DEFAULT_BANK_SET:     'default_bank_set',

  // --- Documents ---
  DOCUMENT_UPLOADED:     'document_uploaded',
  DOCUMENT_VIEWED:       'document_viewed',
  LEASE_DOCUMENT_VIEWED: 'lease_document_viewed',

  // --- Maintenance ---
  MAINTENANCE_REQUEST_VIEWED:    'maintenance_request_viewed',
  MAINTENANCE_DOCUMENT_UPLOADED: 'maintenance_document_uploaded',

  // --- Renters Insurance ---
  RENTERS_INSURANCE_WIDGET_CLICKED: 'renters_insurance_widget_clicked',
});

export default EVENTS;
